module.exports = __webpack_public_path__ + "img/服务案例03.5b52234c.png";